import loginRequest from './loginRequest';

export default token => loginRequest({ data: { token } });
